import React from "react";
import LoginButton from "./LoginButton";
import './LoginPage.less';

const LoginPage = () => {



	return (
		<div className={'login-page'}>
			<img className={'insite-logo'} alt="InSite Logic" src="https://insitelogic.com.au/wp-content/uploads/insite-logo-white1-large.png"/>
			<div className={'login-container'}>
				<h2>JSON Updater</h2>
				<LoginButton/>
			</div>
		</div>
	);
};

export default LoginPage;